import { PropsWithChildren, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import isFunction from "lodash/isFunction";
import { GenericFallback } from "components/common/ErrorBoundaries";
import { useLegalAcknowledgement } from "context/LegalAcknowledgementContext/useLegalAcknowledgement";
import { TLegalAcknowledgementAccessCheck } from "../accessChecks/accessChecks.types";

type TLegalAcknowledgementGuardProps = PropsWithChildren<{
  check: TLegalAcknowledgementAccessCheck;
  onDenied?: () => ReactElement | void;
}>;

export const LegalAcknowledgementGuard = ({
  check,
  onDenied,
}: TLegalAcknowledgementGuardProps): ReactElement => {
  const { t } = useTranslation("common", { keyPrefix: "messages" });
  const { legalAcknowledgements } = useLegalAcknowledgement();

  const isAccessGranted = check({
    legalAcknowledgements,
  });

  if (isAccessGranted) {
    return <Outlet />;
  }

  if (isFunction(onDenied)) {
    return onDenied() ?? <></>;
  }

  return <GenericFallback message={t("genericNoAccess")} />;
};
